import React from 'react';
import { TASK_STATUS_COLORS, TASK_STATUS_LABELS } from '../../constants/taskStatuses';
import StatusPill from '../ui/StatusPill';

export default function TaskStatusBadge({ status, size, className = '', ...rest }) {
  const colorClasses = TASK_STATUS_COLORS[status] || 'bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-300';
  const label = TASK_STATUS_LABELS[status] || status || '-';
  return <StatusPill label={label} colorClass={colorClasses} size={size} className={className} {...rest} />;
}
